/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
    /**
     * Extends ng-switch-when directive with ability to pass variables (arrays too)
     * */
    angular.module("meevo.components.controls")
        .directive('meevoSwitchWhen', function() {
            return {
                priority: 1200,
                transclude: 'element',
                require: '^ngSwitch',
                link: function(scope: any, element: JQuery, attrs: angular.IAttributes, ctrl, $transclude) {
                    let caseStatements = scope.$eval(attrs['meevoSwitchWhen']);

                    caseStatements = angular.isArray(caseStatements) ? caseStatements : [caseStatements];

                    angular.forEach(caseStatements, function(statement) {
                        statement = '!' + statement;
                        ctrl['cases'][statement] = ctrl['cases'][statement] || [];
                        ctrl['cases'][statement].push({
                            transclude: $transclude,
                            element
                        });
                    });
                }
            };
        });
}